import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  faCartShopping,
  faMagnifyingGlass,
  faShop,
  faTimes,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { getCartItemsLength } from "../utils/cookieUtils";
import axiosInstance from "../utils/axiosInstance";
import ProductSkeleton from "../utils/ProductSkeleton";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const searchInputRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const hasSearchResults = searchResults.length > 0;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };

  const closesearch = () => {
    setSearchResults([]);
    setSearchTerm([]);
    setSearchResults([]);
    setIsSearchFocused();
  };

  const handleSearch = async () => {
    try {
      // Show loading state (using a loading state variable)

      const response = await axiosInstance.get(
        `/api/products/search/details?name=${searchTerm}`
      );

      if (response.status === 200) {
        const data = response.data;

        if (Array.isArray(data)) {
          setSearchResults(data);
          setLoading(false);
        } else {
          console.error("Invalid response data:", data);
          setSearchResults([]);
        }
      } else {
        console.error("Invalid response status:", response.status);
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResults([]);
    }
  };

  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolling(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigationLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/service", label: "Services" },
    { to: "/cake", label: "Cakes" },
    { to: "/gallery", label: "Gallery" },
    { to: "/contact", label: "Contact" },
  ];

  const renderLinks = (links) => {
    return links.map((link) => (
      <Link key={link.to} to={link.to} className="text-amber-600 py-2">
        {link.label}
      </Link>
    ));
  };

  const [cartItemsLength, setCartItemsLength] = useState(0);

  useEffect(() => {
    // Fetch the length of items in the cart
    const length = getCartItemsLength();
    setCartItemsLength(length);
  }, []);

  return (
    <>
      <nav
        className={`p-4 rounded-tb-lg  fixed top-0 w-full z-50 ${
          scrolling ? "bg-gray-800" : "bg-transparent"
        }`}
      >
        <div className="container mx-auto flex items-center justify-around">
          <div className="text-amber-600 font-bold text-lg md:text-sm lg:text-2xl font-nav">
            <Link to="/" className="text-amber-600 py-2">
              {/* <img src="/images/logo.png" alt="Sauraha Gourmet Logo" className="h-20 absolute -mt-10 w-auto mr-2" /> */}
              Sauraha Gourmet
            </Link>
          </div>

          <div className="hidden md:flex md:text-sm lg:text-lg space-x-4  font-semibold">
            {renderLinks(navigationLinks)}
          </div>

          <div className=" items-center justify-end mt-4 md:w-60 md:mt-0 hidden md:block mr-20">
            <div className="relative md:flex flex justify-around w-80 ">
              <input
                type="search"
                placeholder="Search here.."
                className="py-2 px-4 block w-32 border border-gray-400 rounded-sm  md:w-auto leading-5  transition duration-150 ease-in-out sm:text-sm sm:leading-5 bg-brown-200"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={handleSearchFocus}
                ref={searchInputRef}
              />
              <button className="text-amber-600 ml-2" onClick={handleSearch}>
                <FontAwesomeIcon
                  className="text-1xl"
                  icon={faMagnifyingGlass}
                />
              </button>
              <button className="text-amber-600 ml-2 relative">
                <span className="absolute text-xs top-0 left-4 bg-red-500 rounded-full px-1 text-white -mt-1 -mr-1">
                  {cartItemsLength}
                </span>
                <FontAwesomeIcon
                  className="flex text-xl justify-center"
                  icon={faCartShopping}
                />
              </button>
              <button className="text-amber-600 ml-2 relative">
                <Link to={'/profile'}>  
                <FontAwesomeIcon
                  className="flex text-2xl justify-center"
                  icon={faUser}
                />
                </Link>
              </button>
            </div>
          </div>

          {hasSearchResults ? (
            <div className="hidden md:block mt-80 absolute right-24 bg-white p-4 overflow-y-auto max-h-60 border rounded shadow-lg">
              <button className="text-amber-600 ml-auto" onClick={closesearch}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <div className="mt-4">
                {loading ? (
                  // Show loader component here
                  <ProductSkeleton />
                ) : // Show search results or "No result found" message
                searchResults.length > 0 ? (
                  searchResults.map((product) => (
                    <div key={product.id} className="flex mb-4">
                      <Link to={`/product/${product._id}`}>
                        <div className="w-24">
                          <img
                            src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                            alt=""
                            className="w-full h-auto"
                          />
                        </div>
                        <div className="ml-4">
                          <p className="text-gray-800 font-bold">
                            {product.name}
                          </p>
                          <p className="text-gray-600">{product.description}</p>
                          <p className="text-green-600">NPR:{product.price}</p>
                          {product.discountprice && (
            <p className="text-green-500 ml-3 text-sm font-semibold">
            {product.discountprice}
              </p>
            )}
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p>No result found</p>
                )}
              </div>
            </div>
          ) : null}

          <div className="md:hidden">
            <button className="text-amber-600" onClick={handleSearchFocus}>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>
          </div>
          <div className="md:hidden">
            <button className="text-amber-600" onClick={toggleMenu}>
              <span className="material-icons">menu</span>
            </button>
          </div>
        </div>

        {isSearchFocused && (
          <div className="md:hidden fixed inset-0 bg-white bg-opacity-50 z-10 w-full">
            <div className="top-20 relative bg-white w-full p-4">
              <div className="flex justify-end">
                <button
                  className="text-amber-600 ml-2 rounded-full bg-gray-300 p-2"
                  onClick={closesearch}
                >
                  <FontAwesomeIcon className="text-1xl" icon={faXmark} />
                </button>
              </div>
              <p className="text-xl text-amber-600">Search Your Items here</p>
              <div className="flex items-center">
                <input
                  type="search"
                  placeholder="Search Items"
                  className="text-amber-600 py-2 px-4 w-full"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button className="text-amber-600 ml-2" onClick={handleSearch}>
                  <FontAwesomeIcon
                    className="text-1xl"
                    icon={faMagnifyingGlass}
                  />
                </button>
              </div>
              <div className="mt-3 bg-white p-2 w-full">
                {searchResults.map((product) => (
                  <div key={product.id}>
                    <div className="flex">
                      <div className="w-24">
                        <img
                          src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                          alt=""
                        />
                      </div>
                      <div className="">
                        <p>{product.description}</p>
                        <p>{product.name}</p>
                        <p>${product.price}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {showMenu && (
          <div className="md:hidden  fixed inset-0 bg-black bg-opacity-50 z-50">
            <div className="flex flex-col fixed top-0 right-0 h-full bg-gray-800 w-64 p-4">
              <button className="text-white" onClick={toggleMenu}>
                Close
              </button>
              {renderLinks(navigationLinks)}
            </div>
          </div>
        )}

        {/* show below in nav */}
      </nav>
      <div className="md:hidden bg-white w-full z-50 md:w-96 h-16 mx-auto fixed bottom-0">
        <div className="flex justify-around items-center w-full h-full">
          <div className="">
            <Link to="/">
              <FontAwesomeIcon
                className="h-5"
                icon={faShop}
                style={{ color: "rgb(217 119 6)" }}
              />
            </Link>
          </div>
          <div className="">
            <Link to="/gallery">
              <FontAwesomeIcon
                className="h-5"
                icon={faFilter}
                style={{ color: "rgb(217 119 6)" }}
              />
            </Link>
          </div>
          <div className="">
            <button className="text-amber-600 ml-2 relative">
              <span className="absolute text-xs top-0 left-4 bg-red-500 rounded-full px-1 text-white -mt-1 -mr-1">
                {cartItemsLength}
              </span>
              <Link to="/cart">
                <FontAwesomeIcon
                  className="flex text-xl justify-center"
                  icon={faCartShopping}
                />
                
              </Link>
            </button>
          </div>
          <div className="">
            <button className="text-amber-600 ml-2 relative">
              
              <Link to="/profile">
                <FontAwesomeIcon
                  className="flex text-xl justify-center"
                  icon={faUser}
                />
              </Link>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
